import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from 'Components/Organisms/UserProvider/useUser';
import { ROUTES, ROUTES_WITH_SUBROUTES } from 'Utils/constants';
import { isLocalStorageAvailable } from 'Utils/storage';
import useProjectSelected from 'Hooks/useProjectSelected';
import AppSkeleton from 'Components/Molecules/AppSkeleton/AppSkeleton';
import useUserSettings from 'Hooks/useUserSettings';

const isValidPath = (path) => {
    const hasRoute = Object.values(ROUTES).includes(path);
    if (hasRoute) return true;

    const hasSubroute = ROUTES_WITH_SUBROUTES.some((subroute) => {
        const regex = new RegExp(`^${subroute}(/[a-zA-Z0-9-]+)+$`);
        return regex.test(path);
    });

    return hasSubroute;
};

export default function GuardPrivate() {
    const { user } = useUser();
    const { pathname } = useLocation();
    const { project, isLoading } = useProjectSelected();
    const { isLoading: isLoadingSettings } = useUserSettings();

    if (!user) {
        if (isValidPath(pathname) && isLocalStorageAvailable()) {
            sessionStorage.setItem('redirect', pathname);
        }
        return <Navigate to={ROUTES.signIn} />;
    }

    if (isLoading || isLoadingSettings) {
        return <AppSkeleton />;
    }

    if (!user.set_project_workspace_id) {
        return <Navigate to={ROUTES.selectWorkspace} />;
    }

    if (!project.is_onboarded) {
        return <Navigate to={ROUTES.onboarding} />;
    }

    return <Outlet />;
}
